export interface IGpsItemsForList {
    id: number,
    clusterNumber: number,
    chainId: number,
    positionNumber: number,
    swapNumber: string,
    donorId: number,
    recipientId: number,
    donorAlias: string,
    recpAlias: string,
    donorCenter: string,
    recipientCenter: string,
    gpsNumber: number,
    gpsLink: string,
    outboundTrackingNumber: string,
    returnTrackingNumber: string,
    gpsStatus: number,
    gpsComments: string,
    statusDate: string,
    transportEmailDate: string,
    kidneyDeliveryDate: string,
    dcTimeZone: string,
    rcTimeZone: string,
    rdnCenter: string,
    businessDays: number,
    daysTillShip: number,
    isSelected: boolean,
    gpsDeviceId: number,
    imei: string,
    vendorId: number,
    vendor: string
}